(() => {
  const updatePromoThreshold = (root) => {
    if (!root) return;

    const replaceText = (node) => {
      if (!node || node.nodeType !== Node.TEXT_NODE) return;
      const value = node.nodeValue || '';
      if (!/\bspend\b/i.test(value) || !/\$70/i.test(value)) return;
      const updated = value.replace(/(\bspend(?:\s+over)?\s*)\$70\+?/gi, '$1$90+');
      if (updated !== value) node.nodeValue = updated;
    };

    if (root.nodeType === Node.TEXT_NODE) {
      replaceText(root);
      return;
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const parent = node.parentElement;
      if (parent && parent.closest('script,style,textarea')) continue;
      replaceText(node);
    }
  };

  const ready = () => {
    // Keep every rendered 15% spend-threshold message aligned to the current $90 offer,
    // including legacy 2024 modules that may be re-enabled in Theme Editor.
    updatePromoThreshold(document.body);
    const promoObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') updatePromoThreshold(mutation.target);
        mutation.addedNodes.forEach((node) => updatePromoThreshold(node));
      });
    });
    promoObserver.observe(document.body, { childList: true, subtree: true, characterData: true });

    // PDP-only enhancement. Homepage content is controlled entirely by Theme Editor settings.
    const afterpay = document.getElementById('afterpay_instalments');
    if (afterpay) {
      const row = afterpay.closest('p');
      if (row) row.remove();
    }

    if (document.body.classList.contains('template-product')) {
      const widget = document.getElementById('stamped-main-widget');
      if (widget && !widget.closest('.mg-pdp-reviews-current')) {
        const shell = document.createElement('section');
        shell.className = 'mg-pdp-reviews-current';
        shell.setAttribute('aria-label', 'Customer reviews');
        const head = document.createElement('header');
        head.className = 'mg-pdp-reviews-current__head';
        head.innerHTML = '<p>Verified customer feedback</p><h2>Trusted by golfers. Loved as gifts.</h2><span>Read genuine feedback from customers who chose Mr. Golf for personalised gifts and golf essentials.</span>';
        widget.parentNode.insertBefore(shell, widget);
        shell.appendChild(head);
        shell.appendChild(widget);
      }
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once:true });
  else ready();
})();
